import React, { Component } from 'react';
import _ from 'lodash';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import './stylesheets/DepartmentGroupTable.css';

import { MergeAttributes } from './FlatData';

class MultipleDepartmentGroupTable extends Component {
  constructor(props){
    super(props);

    this.state = {
      selectedDepartmentGroupIds: [],
      selectedDepartmentGroups: [],
      currentPage: 1,
    }

    this.onSelectDepartmentGroup = this.onSelectDepartmentGroup.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.showMemberCount = this.showMemberCount.bind(this);
  }

  showMemberCount(cell, row){
    return row.member_names.length;
  }

  onSelectDepartmentGroup(row, isSelected, e) {
    let { selectedDepartmentGroupIds, selectedDepartmentGroups } = this.state;
    const isIncluded = _.includes(selectedDepartmentGroups, row.id);

    if (isIncluded){
      selectedDepartmentGroups = _.pull(selectedDepartmentGroups, row.id)
      selectedDepartmentGroupIds = _.pull(selectedDepartmentGroupIds, row.id)
    }else{
      selectedDepartmentGroups = _.union(selectedDepartmentGroups, [row.id])
      selectedDepartmentGroupIds = _.union(selectedDepartmentGroupIds, [row.id])
    }

    this.setState({ 
      selectedDepartmentGroups: selectedDepartmentGroups,
      selectedDepartmentGroupIds: selectedDepartmentGroupIds,
    });

    this.props.onSelectDepartmentGroup(selectedDepartmentGroupIds);
  }

  onPageChange(page, sizePerPage) {
    // console.log(this.refs.fwddgtable);

    setTimeout(() => {
      let { data, selectedRowKeys } = this.refs.fwddgtable.state;
      let { selectedDepartmentGroupIds } = this.state
      let selectedDepartmentGroups = []

      selectedDepartmentGroupIds = _.union(selectedDepartmentGroupIds, selectedRowKeys)

      const showingInformeeIds = data.map(row => row.id)
      selectedDepartmentGroups = _.intersection(showingInformeeIds, selectedDepartmentGroupIds)

      this.setState({ 
        selectedDepartmentGroupIds: selectedDepartmentGroupIds,
        selectedDepartmentGroups: selectedDepartmentGroups,
        currentPage: page
      });

      this.props.onSelectDepartmentGroup(selectedDepartmentGroupIds);
    }, 10);
  }

  onSearchChange(searchText, colInfos, multiColumnSearch) {
    // console.log(this.refs.fwdputable);

    setTimeout(() => {
      let { data, selectedRowKeys } = this.refs.fwddgtable.state;
      let { selectedDepartmentGroupIds } = this.state
      let selectedDepartmentGroups = []

      selectedDepartmentGroupIds = _.union(selectedDepartmentGroupIds, selectedRowKeys)

      const showingInformeeIds = data.map(row => row.id)
      selectedDepartmentGroups = _.intersection(showingInformeeIds, selectedDepartmentGroupIds)

      this.setState({ 
        selectedDepartmentGroupIds: selectedDepartmentGroupIds,
        selectedDepartmentGroups: selectedDepartmentGroups,
      });

      this.props.onSelectDepartmentGroup(selectedDepartmentGroupIds);
    }, 10);
  }


  handleSelectAll(isSelected, rows) {
    let { selectedDepartmentGroupIds, selectedDepartmentGroups } = this.state;
    const row_ids = rows.map(row => row.id)
   
    if (isSelected) {
      selectedDepartmentGroups = _.union(selectedDepartmentGroups, row_ids)
      selectedDepartmentGroupIds = _.union(selectedDepartmentGroupIds, selectedDepartmentGroups)
    } else {
      selectedDepartmentGroups = []
      selectedDepartmentGroupIds = _.pullAll(selectedDepartmentGroupIds, row_ids)
    }

    this.setState({
      selectedDepartmentGroupIds: selectedDepartmentGroupIds,
      selectedDepartmentGroups: selectedDepartmentGroups,
    });

    this.props.onSelectDepartmentGroup(selectedDepartmentGroupIds);

    return selectedDepartmentGroups;
  }

  render(){
    const data = MergeAttributes(this.props.department_groups);

    const selectRowProp = {
      mode: 'checkbox',
      clickToSelect: true,
      onSelect: this.onSelectDepartmentGroup,
      selected: this.state.selectedDepartmentGroups,
      onSelectAll: this.handleSelectAll
    };
    const options = {
      sizePerPageList: [],
      onPageChange: this.onPageChange.bind(this),
      onSearchChange: this.onSearchChange.bind(this),
      page: this.state.currentPage,
      selected: this.state.selectedDepartmentGroups,
    };

    return(
      <div className="row">
        <div className="col-12 rui-wf-action-dg-tb">
          <BootstrapTable 
            ref='fwddgtable'
            data={data}
            search={ true }
            multiColumnSearch={ true }
            selectRow={ selectRowProp }
            options={ options }
            striped
            hover
            condensed
            pagination
            version='4'
            tableContainerClass={'table-sm'}>
              <TableHeaderColumn isKey dataField='id' hidden></TableHeaderColumn>
              <TableHeaderColumn dataField='name' dataSort={ true }>ชื่อกลุ่ม</TableHeaderColumn>
              <TableHeaderColumn dataField='member_names' dataSort={ true }>คนภายในกลุ่ม</TableHeaderColumn>
              <TableHeaderColumn  dataField='member_count' 
                                  dataSort={ true }
                                  width='65'
                                  dataFormat={this.showMemberCount}>
                                    จำนวน(คน)
              </TableHeaderColumn>
          </BootstrapTable>
        </div>
      </div>
    )
  }
}

export default MultipleDepartmentGroupTable;



// WEBPACK FOOTER //
// ./src/components/MultipleDepartmentGroupTable.js